import React from 'react';
import styled from 'styled-components';

import EntryPointExceptionHeader from './EntryPointExceptionHeader';
import MinutesInputField, { TimeUnits } from 'src/presentation/components/pages/shared/MinutesInputField';
import RoutingGroupDropDown from 'src/presentation/components/pages/channels/entryPoints/components/RoutingGroupDropDown';
import useDefaultSlaMinutes from 'src/presentation/components/pages/channels/entryPoints/hooks/useDefaultSlaMinutes';
import { EntryPointItemRow } from 'src/presentation/components/pages/channels/entryPoints/components/EntryPointLayouts';
import { Section } from 'src/presentation/components/forms/Layout';

export default function EntryPointDefaults({ 'data-aid': dataAid, inboxes, inboxesMap, className }): JSX.Element {
  const defaultSlaMinutes = useDefaultSlaMinutes({ baseAttr: '', inboxesMap });

  return (
    <DefaultsSection data-aid={`${dataAid}-defaults`} className={className}>
      <StyledSectionContainer>
        <EntryPointExceptionHeader hideEntryPointColumn={true} inboxHeaderName="Default Inbox" />
        <EntryPointItemRow
          className="entry-point-exception-item"
          inboxElement={
            <RoutingGroupDropDown baseAttr="" inboxes={inboxes} inboxesMap={inboxesMap} className="inbox-dropdown" />
          }
          slaElement={
            <MinutesInputField
              allowDecimalDigits={true}
              attr="slaSeconds"
              data-aid="slaSeconds"
              displayUnits={TimeUnits.Minutes}
              sourceUnits={TimeUnits.Seconds}
              placeholder={defaultSlaMinutes.toString()}
            />
          }
        />
      </StyledSectionContainer>
    </DefaultsSection>
  );
}

export const DefaultsSection = styled(Section)`
  margin: 0 0 16px 0;
`;

export const StyledSectionContainer = styled.div`
  line-height: ${p => p.theme.lineHeight.base};
  padding: 0 0;
`;
